import { application } from "../../app"

import AccountsContactsCommunicationSwitchController from "./accounts/contacts/communication_switch_controller"
application.register("accounts--contacts--communication-switch", AccountsContactsCommunicationSwitchController)

import DealsShowroomAgentConnectionController from "./public/deals_showroom/agent_connection_controller"
application.register("deals-showroom--agent-connection", DealsShowroomAgentConnectionController)

import ImageContentController from "./image_content_controller"
application.register("customer-space--image-content", ImageContentController)